module.exports = __webpack_public_path__ + "static/media/icon-open-left.befd4471.svg";